module.exports = __webpack_public_path__ + "16cabe8b85a337879a78f6b51baeb423.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/party-dress.png
// module id = 1925
// module chunks = 0